import { render, staticRenderFns } from "./TaskNodePng.vue?vue&type=template&id=10406f96&scoped=true"
import script from "./TaskNodePng.vue?vue&type=script&lang=js"
export * from "./TaskNodePng.vue?vue&type=script&lang=js"
import style0 from "./TaskNodePng.vue?vue&type=style&index=0&id=10406f96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10406f96",
  null
  
)

export default component.exports